<div [hidden]="newBsModalRef">
  <div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <button (click)="cancel()" aria-label="Close" class="modal-close" type="button">
      <font-awesome [icon]="'fa-regular fa-xmark'"></font-awesome>
    </button>
  </div>

  <div class="modal-body">
    <div *ngIf="customerType === 'Customer'" class="d-flex mb-30px">
      <input (keydown.enter)="showList()" [(ngModel)]="search"
             class="form-control rounded"
             placeholder="Email or Phone Number"
             type="text">
      <button (click)="showList()" [disabled]="!search" class="btn btn-dark ml-24px btn-search" type="button">Search
      </button>
    </div>

    <!-- Customer List -->
    <div *ngIf="customerType === 'Customer' && customerData && customerData.length > 0">
      <h5 class="mb-3">Customers</h5>
      <div class="table-wrapper py-0">
        <perfect-scrollbar [style.height]="'200px'">
          <table class="table align-middle table-nowrap table-check">
            <thead>
            <tr>
              <th>BP No.</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Phone Number</th>
              <th>Email</th>
              <th>State</th>
            </tr>
            </thead>
            <tbody>
            <tr (click)="selectRow(customer)"
                *ngFor="let customer of customerData;"
                [class.active]="customer === selectedData">
              <td>{{ customer.bpNo }}</td>
              <td>{{ customer.firstName }}</td>
              <td>{{ customer.lastName }}</td>
              <td>{{ customer.homePhone || customer.cellPhone || customer.workPhone }}</td>
              <td>{{ customer.email }}</td>
              <td>{{ customer.address?.state }}</td>
            </tr>
            </tbody>
          </table>
        </perfect-scrollbar>
      </div>
    </div>

    <!-- New Button Between Lists -->
    <div *ngIf="customerType === 'Customer' && isEditable" class="d-flex justify-content-end my-3">
      <button (click)="openCustomerDetail(customerType, true)" class="btn btn-185px btn-outline-dark" type="button">
        New
      </button>
    </div>

    <!-- Store Contact List -->
    <div *ngIf="customerType === 'Customer' && storeContactData && storeContactData.length > 0">
      <h5 class="mb-3">Store Contacts</h5>
      <div class="table-wrapper py-0">
        <perfect-scrollbar [style.height]="'200px'">
          <table class="table align-middle table-nowrap table-check">
            <thead>
            <tr>
              <th>BP No.</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Phone Number</th>
              <th>Email</th>
              <th>State</th>
            </tr>
            </thead>
            <tbody>
            <tr (click)="selectStoreContact(contact)"
                *ngFor="let contact of storeContactData;"
                [class.active]="contact === selectedData">
              <td>{{ contact.employeeNo }}</td>
              <td>{{ contact.firstName }}</td>
              <td>{{ contact.lastName }}</td>
              <td>{{ contact.homePhone || contact.cellPhone || contact.workPhone || contact.tel }}</td>
              <td>{{ contact.email }}</td>
              <td>{{ contact.address?.state || '' }}</td>
            </tr>
            </tbody>
          </table>
        </perfect-scrollbar>
      </div>
    </div>

    <!-- Store Type List (Original) -->
    <div *ngIf="customerType === 'Store'" class="table-wrapper py-0">
      <perfect-scrollbar [style.height]="'380px'">
        <table class="table align-middle table-nowrap table-check">
          <thead>
          <tr>
            <th>BP No.</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Phone Number</th>
            <th>Email</th>
            <th>State</th>
          </tr>
          </thead>
          <tbody>
          <tr (click)="selectRow(customer)"
              *ngFor="let customer of customerData;"
              [class.active]="customer === selectedData">
            <td>
              <ng-container *ngIf="![companies.SeaIm].includes(this.company)">{{ customer.employeeNo }}</ng-container>
              <ng-container *ngIf="[companies.SeaIm].includes(this.company)">{{ this.bpNo }}</ng-container>
            </td>
            <td>{{ customer.firstName }}</td>
            <td>{{ customer.lastName }}</td>
            <td>{{ customer.homePhone || customer.cellPhone || customer.workPhone }}</td>
            <td>{{ customer.email }}</td>
            <td>{{ customer.address?.state }}</td>
          </tr>
          </tbody>
        </table>
      </perfect-scrollbar>
    </div>
  </div>

  <div *ngIf="customerType === 'Store'" class="modal-footer">
    <div class="d-flex justify-content-end w-100">
      <button (click)="openCustomerDetail(customerType, true)" *ngIf="isEditable" class="btn btn-185px btn-outline-dark"
              type="button">
        new
      </button>
    </div>
  </div>

</div>
